__turbopack_context__.v({
  "container": "MhF_fq_container",
  "label": "MhF_fq_label",
  "redirectTile": "MhF_fq_redirectTile",
  "wrapper": "MhF_fq_wrapper",
});
